import type { CustomNoRowsOverlayProps } from "ag-grid-react";
import React from "react";

import { faMagnifyingGlass } from "@fortawesome/pro-duotone-svg-icons";

import Icon from "../../../components/Icon";
import Spacer from "../../../components/Spacer";
import Typography from "../../../components/Text";

import css from "./custom-overlay.module.scss";

// the purpose of this class is to provide a custom overlay that displays
// the magnifying glass icon with the message: "No results found /n Please try again."
// on top of the ag grid when no data is returned

// AGGrid documentation: https://www.ag-grid.com/react-data-grid/overlays/
// AGGrid Docs example code: https://www.ag-grid.com/react-data-grid/overlays/#custom-no-rows-overlay

// this is instead of the default overlay "no rows to show"

export const CustomNoRowsOverlay = (
	props: CustomNoRowsOverlayProps & { primaryMessage: string; secondaryMessage: string }
) => {
	return (
		<div>
			<div className={css.iconContainer}>
				<Icon className={css.icon} icon={faMagnifyingGlass} size="regular" />
			</div>

			<Spacer height={1} />
			<Typography size="paragraph-2" weight="semi-bold">
				{props.primaryMessage}
			</Typography>

			<Spacer height={1} />
			<Typography size="paragraph-3" weight="regular">
				{props.secondaryMessage}
			</Typography>
		</div>
	);
};
